import { render, staticRenderFns } from "./Charts.vue?vue&type=template&id=22b354b9&scoped=true"
import script from "./Charts.vue?vue&type=script&lang=js"
export * from "./Charts.vue?vue&type=script&lang=js"
import style0 from "./Charts.vue?vue&type=style&index=0&id=22b354b9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../Users/wencesszelagowski/Downloads/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b354b9",
  null
  
)

export default component.exports